export const SET_EXERCISE = 'SET_EXERCISE';
export const SET_WINDOW_SIZE = 'SET_WINDOW_SIZE';